import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { ElMessage } from 'element-plus';
import request from '../api';
/**
 * @description 驼峰转下划线
 * @param {string} str 转化目标字符串
 * @returns {string}
 * */
export function toSnakeCase(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
}
/**
 * 计算table序号
 * @param res
 * @param pagination
 */
export function calcTableIndex(res, pagination) {
  return (res.list || []).map((p, i) => {
    p._tableIndex = 1 + i + (pagination.pageIndex - 1) * pagination.pageSize;
    return p;
  });
}
/**
 * 时间格式化
 * @param time
 * @returns
 */
export const formatTime = time => {
  const date = new Date(time);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
/**
 * 复制文本，兼容 HTTP 和 HTTPS 环境
 * @param text 要复制的文本
 * @returns Promise<boolean> 复制是否成功
 */
export const copyTexts = async text => {
  try {
    // 优先使用 Clipboard API（仅在 HTTPS 环境下可用）
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      ElMessage.success('复制成功');
      return true;
    } else {
      // 在 HTTP 环境下使用 execCommand 方法
      const textArea = document.createElement('textarea');
      textArea.value = text;
      // 防止滚动
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.position = 'fixed';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      if (successful) {
        ElMessage.success('复制成功');
        return true;
      } else {
        ElMessage.error('复制失败，请手动复制');
        return false;
      }
    }
  } catch (err) {
    console.error('复制失败:', err);
    ElMessage.error('复制失败，请手动复制');
    return false;
  }
};
/**
 * 复制文本
 * @param value
 */
export const copyText = value => {
  const inputNode = document.createElement('input');
  inputNode.value = value;
  document.body.appendChild(inputNode);
  inputNode.select();
  document.execCommand('Copy');
  ElMessage.success('复制成功');
  document.body.removeChild(inputNode);
};
/**
 * 节流
 * @param func
 * @param delay
 * @returns
 */
export const throttle = (func, delay = 500) => {
  let timerId;
  let lastRan = 0;
  return function (...args) {
    const now = Date.now();
    if (now - lastRan >= delay) {
      func.apply(null, args);
      lastRan = now;
    } else {
      clearTimeout(timerId);
      timerId = setTimeout(function () {
        func.apply(null, args);
        lastRan = now;
      }, delay - (now - lastRan));
    }
  };
};
/**
 * 防抖
 * @param func
 * @param wait
 * @returns
 */
export function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(null, args), wait);
  };
}
/**
 * 获取对象类型
 * @param variable
 * @returns
 */
export function getObjectType(variable) {
  return Object.prototype.toString.call(variable).slice(8, -1);
}
/**
 * 下载
 * @param url
 */
export function download(url) {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  // 将 <a> 元素添加到 DOM
  document.body.appendChild(a);
  // 触发点击事件
  a.click();
  // 下载完成后移除 <a> 元素
  document.body.removeChild(a);
}
/**
 * 通过blob下载
 * @param num
 * @returns
 */
export function blobDownload(url, filename = 'video.mp4') {
  const elbox = ElMessage({
    type: 'warning',
    message: '下载中，请勿关闭页面。',
    duration: 0
  });
  fetch(url, {
    method: 'GET'
  }).then(data => data.blob()).then(blob => {
    const reader = new FileReader();
    reader.onload = function () {
      var _reader$result;
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = ((_reader$result = reader.result) === null || _reader$result === void 0 ? void 0 : _reader$result.toString()) || '';
      a.download = filename; // 指定下载文件名
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    reader.readAsDataURL(blob);
  }).catch(() => {
    ElMessage({
      type: 'error',
      message: '下载失败，请检查网络状态后重试。'
    });
  }).finally(() => elbox.close());
}
export function extractFileNameAndType(url) {
  const pathname = new URL(url).pathname;
  const fullFileName = pathname.split('/').pop() || ''; // 添加默认值
  const [fileName, fileType] = fullFileName.split(/(?=\.[^.]+$)/);
  return {
    fileName,
    fileType
  };
}
/**
 * 检查文件名是否合法
 * @param filename
 * @returns {boolean}
 */
export function isValidFilename(filename) {
  // 定义不允许的字符
  const invalidChars = /[<>:"/\\|?*\x00-\x1F]/;
  return !invalidChars.test(filename);
}
export function blobDownloadUpgrades(url, custFilename, onProgress) {
  // 验证URL
  if (!url || typeof url !== 'string') {
    ElMessage.error('无效的下载地址');
    return;
  }
  let filename;
  try {
    // 提取文件信息
    const {
      fileName: name,
      fileType
    } = extractFileNameAndType(url);
    // 文件名处理
    filename = custFilename && isValidFilename(custFilename) ? custFilename + (custFilename.includes('.') ? '' : fileType) : name + fileType;
  } catch (error) {
    console.error('URL解析错误:', error);
    ElMessage.error('无效的文件地址');
    return;
  }
  const elbox = ElMessage({
    type: 'warning',
    message: '下载中，请勿关闭页面。',
    duration: 0
  });
  let controller = new AbortController();
  request({
    url,
    method: 'get',
    responseType: 'blob',
    timeout: 300000,
    signal: controller.signal,
    onDownloadProgress: progressEvent => {
      if (progressEvent.total) {
        const percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
        console.log(`${filename}文件，下载进度: ${percentCompleted}%`);
        onProgress === null || onProgress === void 0 || onProgress(percentCompleted);
      }
    }
  }).then(res => {
    const blob = res.data;
    // 检查blob是否有效
    if (!(blob instanceof Blob)) {
      throw new Error('下载内容无效');
    }
    const objectURL = URL.createObjectURL(blob);
    const a = document.createElement('a');
    try {
      // 处理Edge浏览器
      const navigator = window.navigator;
      if (navigator !== null && navigator !== void 0 && navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        a.style.display = 'none';
        a.href = objectURL;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
      }
    } catch (error) {
      console.error('下载操作失败:', error);
      throw new Error('文件下载失败');
    } finally {
      // 清理资源
      document.body.contains(a) && document.body.removeChild(a);
      URL.revokeObjectURL(objectURL);
    }
  }).catch(error => {
    var _error$response;
    console.error('下载错误:', error);
    if (error.name === 'AbortError') {
      ElMessage.warning('下载已取消');
    } else if (error.code === 'ECONNABORTED') {
      ElMessage.error('下载超时，请重试');
    } else if ((_error$response = error.response) !== null && _error$response !== void 0 && _error$response.status) {
      ElMessage.error(`下载失败: ${error.response.status} ${error.response.statusText}`);
    } else {
      ElMessage.error('下载失败，请检查网络后重试');
    }
  }).finally(() => {
    elbox.close();
    controller = null;
  });
}
// 数字格式化工具函数
export function formatNumberForNews(num) {
  if (num === null || num === undefined) return 'N/A';
  // 定义单位和对应的阈值
  const units = [{
    threshold: 1e12,
    unit: 'trillion'
  }, {
    threshold: 1e9,
    unit: 'billion'
  }, {
    threshold: 1e6,
    unit: 'million'
  }, {
    threshold: 1e3,
    unit: 'thousand'
  } // 千
  ];
  // 遍历单位数组，找到第一个匹配的单位
  for (let i = 0; i < units.length; i++) {
    if (num >= units[i].threshold) {
      let quotient = num / units[i].threshold;
      return quotient.toFixed(1) + ' ' + units[i].unit;
    }
  }
  // 如果数字小于1000，直接返回带有千位分隔符的数字
  return num.toLocaleString();
}
/**
 * 深拷贝
 * @param obj
 * @returns
 */
export const deepCopy = obj => {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  if (obj instanceof Date) {
    return new Date(obj);
  }
  if (obj instanceof Array) {
    return obj.map(item => deepCopy(item));
  }
  if (obj instanceof Map) {
    const result = new Map();
    obj.forEach((value, key) => {
      result.set(deepCopy(key), deepCopy(value));
    });
    return result;
  }
  if (obj instanceof Set) {
    const result = new Set();
    obj.forEach(value => {
      result.add(deepCopy(value));
    });
    return result;
  }
  const result = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = deepCopy(obj[key]);
    }
  }
  return result;
};